<template>
  <v-row>
    <v-col>
      <v-col class="d-flex justify-space-between mx-auto flex-wrap container">
        <ToolbarTitles :title="title" />
        <ButtonsCardList @cardView="cardView" />
      </v-col>
      <div v-if="showCard" class="container">
        <CardsView
          :items="operators"
          :subtitle="subtitle"
          :openDialog="openDialog"
          :operator="true"
          @refreshItems="refreshItems"
          :showRefresh="true"
          :heightCard="'140'"
        />
      </div>
      <div v-if="!showCard" class="container">
        <TableWithSearch
          :items="operators"
          :headers="allHeaders"
          :openDialog="openDialog"
          :operator="true"
          @headersUpdated="updateHeaders"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <v-dialog
        v-model="open"
        :max-width="maxWidth[0]"
        hide-overlay
        persistent
        @keydown.esc="reset(false)"
      >
        <FormOrder
          :allFields="parameters.items"
          @save="saveForm"
          @cancel="reset"
          :mode="mode"
          :show="true"
          :showDate="true"
          :showCheck="true"
        />
      </v-dialog>
      <my-dialog
        @closeEditDialog="closeEditDialog"
        :dialog="showModelRelation"
      ></my-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
        :maxWidth="'320'"
      />
    </v-col>
    <v-dialog
      @keydown.esc="cancelChanged"
      persistent
      max-width="500px"
      v-model="changedPass"
    >
      <ChangedPass
        v-if="changedPass"
        :user="itemChangedPass"
        :idOper="idOper"
        @confirmChanged="confirmChanged"
        @cancelChanged="cancelChanged"
      />
    </v-dialog>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import date from "@/store/common/date";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import FormOrder from "@/components/Complement/FormOrder.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import Loader from "@/components/Complement/Loader.vue";
import MyDialog from "./relations/mainRelations.vue";
import operators from "../../../store/operadores/operators";
import moment from "moment";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import ChangedPass from "./commons/changePassword.vue";
import roles from "@/store/autorizaciones/roles";

export default {
  components: {
    TableWithSearch,
    CardsView,
    ToolbarTitles,
    ButtonsCardList,
    FormOrder,
    DeleteDialog,
    Snackbar,
    Loader,
    MyDialog,
    ChangedPass,
  },
  data() {
    return {
      idOper: null,
      itemChangedPass: null,
      changedPass: false,
      showCard: true,
      titleTable: "Operadores_y_Relaciones",
      subtitle: "Login:",
      title: this.$tc("operators.operators"),
      titleDelete: this.$tc("operators.toOperator"),
      isLoading: true,
      maxWidth: ["580px", "500px", "400px"],
      color: "#82A1D0",
      alert: false,
      textAlert: "",
      itemId: null,
      showModelRelation: false,
      headers: {
        operadores: [
          {
            text: "Login",
            value: "login",
            class: "primary secondary--text",
            visible: true,
          },

          {
            text: "Login2",
            value: "login",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Nombre",
            value: "name",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Fecha de alta",
            value: "fecAlta",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Fecha de baja",
            value: "fecBaja",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            width: "100px",
          },
        ],
        empleados: [
          {
            text: "Nombre operador",
            value: "nombre",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Legajo",
            value: "legajo",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            width: "100px",
          },
        ],
        grupos: [
          {
            text: "Grupo",
            value: "nombre",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            width: "100px",
          },
        ],
        unidadesDeNegocios: [
          {
            text: "Nombre",
            value: "name",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Desde",
            value: "dateStart",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Hasta",
            value: "dateEnd",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
          },
          {
            text: "Por defecto",
            value: "isDefaultTable",
            class: "primary secondary--text",
            visible: true,
          },
          {
            text: "Acciones",
            value: "actions",
            class: "primary secondary--text",
            visible: true,
            sortable: false,
            width: "100px",
          },
        ],
      },
      selectedRoles: [],
    };
  },
  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        const savedCount =
          this.allColums && typeof this.allColums === "object"
            ? Object.values(this.allColums).reduce(
                (sum, array) => sum + (Array.isArray(array) ? array.length : 0),
                0,
              )
            : 0;

        const headersCount = Object.values(this.headers).reduce(
          (sum, array) => sum + (Array.isArray(array) ? array.length : 0),
          0,
        );

        if (savedCount === 0 || savedCount !== headersCount) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });

    try {
      await Promise.all([
        operators.dispatch("getOperators"),
        roles.dispatch("getRoles"),
      ]);

      this.isLoading = false;
    } catch (error) {
      console.error(error);
    }
  },

  computed: {
    parameters() {
      return {
        items: [
          {
            id: 1,
            show: true,
            data: "",
            name: "login",
            type: "text",
            label: "Login",
            items: [],
            itemText: "name",
            rules: [
              (v) => !!v || this.$tc("login.required"),
              (v) =>
                v.length <= 50 || this.$t("validation.maxChart", { max: 50 }),
            ],
            order: 1,
          },
          {
            id: 2,
            show: true,
            data: "",
            name: "name",
            type: "text",
            label: "Nombre",
            items: [],
            itemText: "name",
            rules: [
              (v) => !!v || this.$tc("login.required"),
              (v) =>
                v.length <= 50 || this.$t("validation.maxChart", { max: 50 }),
            ],
            order: 2,
          },
          {
            id: 3,
            show: true,
            data: "",
            name: "pass",
            type: "text",
            label: "Password",
            items: [],
            itemText: "name",
            rules: [
              (v) => !!v || this.$tc("login.required"),
              (v) => v.length >= 8 || this.$t("login.mustLengthPass"),
              (v) =>
                /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(v) ||
                this.$t("login.mustContainPass"),
            ],
            order: 3,
          },
          {
            id: 4,
            show: true,
            data: "",
            name: "dbGrupo",
            label: "DB Grupo",
            type: "text",
            items: [],
            itemText: "name",
            rules: [
              (v) => !!v || this.$tc("login.required"),
              (v) =>
                v.length <= 50 || this.$t("validation.maxChart", { max: 50 }),
            ],
            order: 4,
          },
          {
            id: 5,
            show: true,
            data: "",
            name: "email",
            label: "Email",
            type: "text",
            items: [],
            itemText: "name",
            rules: [
              (email) => !!email || this.$tc("login.required"),

              (email) =>
                email.length <= 50 ||
                this.$t("validation.maxChart", { max: 50 }),

              (email) =>
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ||
                this.$t("login.invalidEmailFormat"),
            ],
            order: 5,
          },
          {
            id: 6,
            show: true,
            data: "",
            name: "roles",
            type: "select",
            label: "roles",
            items: this.roles,
            itemText: "name",
            rules: [
              (v) =>
                (v !== null && v !== undefined && v !== "") ||
                this.$tc("editRegistrations.requerid"),
            ],
            order: 6,
            multiple: false,
            disabled: false,
          },
          {
            id: 7,
            show: true,
            data: "",
            name: "token",
            label: "token",
            type: "text",
            items: [],
            itemText: "name",
            rules: [
              (v) => !!v || this.$tc("login.required"),
              (v) =>
                v.length <= 50 || this.$t("validation.maxChart", { max: 50 }),
            ],
            order: 7,
            readonly: true,
          },
        ],
      };
    },
    roles() {
      return roles.state.roles || [];
    },
    allHeaders() {
      return configTable.state.colums.operadores;
    },
    operators() {
      return operators.state.operators.map((operator) => {
        const login = operator.login;
        const nombreOperador = operator.nombre || operator.name || "";

        return {
          ...operator,
          name: nombreOperador,
          subtitle: login,
        };
      });
    },
    padding() {
      return operators.state.paddingNav;
    },

    dataSelects() {
      return [];
    },
    mode: {
      get() {
        return operators.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    open: {
      get() {
        return operators.state.open;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    openDelete: {
      get() {
        return operators.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    async refreshItems() {
      await operators.dispatch("getOperators");
    },
    updateHeaders(headers) {
      const updatedColums = {
        ...configTable.state.colums,
        operadores: headers,
      };

      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = this.allColums;

      const savedCount =
        columnsToSave && typeof columnsToSave === "object"
          ? Object.values(columnsToSave).reduce(
              (sum, array) => sum + (Array.isArray(array) ? array.length : 0),
              0,
            )
          : 0;

      const headersCount =
        this.headers && typeof this.headers === "object"
          ? Object.values(this.headers).reduce(
              (sum, array) => sum + (Array.isArray(array) ? array.length : 0),
              0,
            )
          : 0;

      if (!columnsToSave || savedCount === 0 || savedCount !== headersCount) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };

      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    cancelChanged() {
      this.changedPass = false;
    },
    confirmChanged(idOper, pass) {
      operators.commit("setIdOper", idOper);
      operators.commit("setPass", pass);
      operators.commit("setSendMail", true);
      operators
        .dispatch("changepass")
        .then(() => {
          this.showAlert(this.$tc("operators.changedPassSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(this.$tc("costCenter.changedPassFailed"), "#ff8d58");
        });
      this.changedPass = false;
    },
    generateToken() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        },
      );
    },
    add(form) {
      const rolesArray = Array.isArray(form.roles)
        ? form.roles.map(Number)
        : form.roles !== null && form.roles !== undefined && form.roles !== ""
        ? [Number(form.roles)]
        : [];

      let payload = {
        login: form.login,
        nombre: form.name,
        fecAlta: date.state.dateFrom + "T00:00:00.000Z",
        pass: form.pass,
        dbGrupo: form.dbGrupo,
        correoE: form.email,
        roles: rolesArray,
        token: form.token,
      };

      if (date.state.dateTo !== null) {
        payload.fecBaja = date.state.dateTo + "T00:00:00.000Z";
      }

      operators.commit("setNew", payload);
      operators
        .dispatch("add")
        .then(() => {
          this.showAlert(this.$tc("operators.addOperatorSuccess"), "#82A1D0");
        })
        .catch((e) => {
          this.showAlert(this.$tc("costCenter.addCostCenterError"), "#ff8d58");
        });
      this.reset(false);
    },

    showAlert(text, color) {
      this.alert = true;
      this.textAlert = text;
      this.color = color;

      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    saveForm(items) {
      switch (this.typeForm) {
        case "add":
          this.add(items);
          break;
        case "edit":
          this.editModelLiquidation(items);
          break;
        default:
          break;
      }
    },
    cardView(value) {
      this.showCard = value;
    },
    async resetDate() {
      const today = moment().format("YYYY-MM-DD");
      await date.commit("setDateFrom", today);
      await date.commit("setDateTo", null);
    },

    async reset(value) {
      this.resetDate();
      operators.commit("setOpen", value);
      this.parameters.items.forEach((item) => {
        item.data = "";
      });
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const day = String(date.getUTCDate()).padStart(2, "0");

      return `${day}-${month}-${year}`;
    },
    async setEdit() {
      operators.commit("setIdOper", this.itemId);
      await operators.dispatch("getOperatorId", this.itemId);
    },
    async openDialog(type, item) {
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          this.parameters.items[6].data = this.generateToken();
          operators.commit("setMode", this.$tc("operators.addOperator"));
          operators.commit("setOpen", true);
          break;
        case "edit":
          this.itemId = item.id;
          operators.commit("setMode", this.$tc("operators.editOperator"));

          await this.setEdit(item);
          this.openEditDialog();

          break;
        case "delete":
          operators.commit("setOpenDelete", true);
          this.itemToDelete = item.id;
          break;
        case "changedPass":
          this.idOper = item.id;
          this.itemChangedPass = item.login;
          this.changedPass = true;
          break;
        default:
          break;
      }
    },

    deleteItem() {
      operators.commit("setItemDelete", this.itemToDelete);
      operators
        .dispatch("delete")
        .then(() => {
          this.openDelete = false;
          operators.commit("setOpenDelete", false);
          this.showAlert(
            this.$tc("operators.deleteOperatorSuccess"),
            "#82A1D0",
          );
        })
        .catch((e) => {
          this.showAlert(
            this.$tc("modelsLiquidations.deleteModelLiquidationError"),
            "#ff8d58",
          );
        });
    },

    cancelDelete() {
      this.openDelete = false;
      operators.commit("setOpenDelete", false);
    },
    openEditDialog() {
      this.$forceUpdate();
      this.showModelRelation = true;
    },
    closeEditDialog() {
      this.$forceUpdate();
      this.showModelRelation = false;
      this.resetDate();
    },
  },
};
</script>
<style>
.v-toolbar__content {
  margin: 0;
}
.container {
  max-width: 100%;
  padding-top: 1vh;
  padding-bottom: 1vh;
}
</style>
